import React from "react";
import { Download } from "../../../components/icons/svg/outline";
import { usePayoutWeekSummaryDownload } from "./usePayoutWeekSummaryDownload";

/**
 * Downloads a brief worker-shift CSV for one payroll week.
 *
 * @param {Object} props Component props.
 * @param {string} props.weekEnding Week-ending date (YYYY-MM-DD).
 * @returns {JSX.Element} Download summary control.
 */
const DownloadWeekSummaryButton = ({ weekEnding }) => {
  const { download, isDownloading, error } = usePayoutWeekSummaryDownload(weekEnding);

  return (
    <div className="flex flex-col items-end">
      <button
        type="button"
        className="inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-2.5 py-1 text-xs font-semibold text-gray-700 shadow-sm outline-none transition hover:bg-gray-50 focus:ring-2 focus:ring-secondary-100 disabled:cursor-not-allowed disabled:opacity-50"
        onClick={download}
        disabled={isDownloading}
        title="Download a brief CSV of worker entered (not payout) hours for this week"
      >
        <Download className="h-3.5 w-3.5" />
        {isDownloading ? "Downloading..." : "Download Summary"}
      </button>
      {error ? (
        <span className="mt-1 text-[11px] font-semibold text-red-600">{error}</span>
      ) : null}
    </div>
  );
};

export default DownloadWeekSummaryButton;
